import { render, staticRenderFns } from "./dWarning.vue?vue&type=template&id=cf1ad920&scoped=true&"
import script from "./dWarning.vue?vue&type=script&lang=js&"
export * from "./dWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1ad920",
  null
  
)

export default component.exports